// Types
import { Selector } from 'react-redux';
import { HotTableStoreState, HotTableStoreActiveTable } from './hotTableStoreTypes';
import { TableDataVersion } from '../../../../common/table/TableTypes';

export const getActiveTable: Selector<HotTableStoreState, HotTableStoreActiveTable | null> = (hotTableState) =>
    hotTableState.activeTable;

export const getActiveTableDataVersion: Selector<HotTableStoreState, TableDataVersion | undefined> = (hotTableState) =>
    hotTableState.activeTable?.tableDataVersion;
